export default __webpack_public_path__ + "static/media/slide-1.df5eb487.jpg";